const getShouldNotDisplayByDate = until => Date.now() > until;
export default getShouldNotDisplayByDate;